"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollableTabs = void 0;
var React = require("react");
var normalize_scroll_left_1 = require("normalize-scroll-left");
var Tab_1 = require("../Tab/Tab");
var animations_1 = require("../../../common/animations");
var dataHooks_1 = require("../dataHooks");
var ScrollableTabs_st_css_1 = require("./ScrollableTabs.st.css");
var keyCodes_1 = require("../../../common/keyCodes");
var GenericComponent_1 = require("../GenericComponent");
var isEqual = require('lodash/isEqual');
var ScrollableTabs = /** @class */ (function (_super) {
    __extends(ScrollableTabs, _super);
    function ScrollableTabs(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedIndicatorRect: {
                left: 0,
                width: 0,
            },
            focusedTabIdx: _this.props.activeTabIndex,
        };
        _this._tabRefs = {};
        _this._scrollToViewIfNeeded = function () {
            var _a = _this.props, rtl = _a.rtl, scrollButtons = _a.scrollButtons, activeTabIndex = _a.activeTabIndex;
            var left = scrollButtons.left, right = scrollButtons.right;
            var selectedTabRef = _this._getSelectedTabRef(activeTabIndex);
            if (selectedTabRef) {
                var tabOffsetWidth = selectedTabRef.offsetWidth, tabOffsetLeft = selectedTabRef.offsetLeft;
                var navElement = _this._navRef.current;
                var navOffsetWidth = navElement.offsetWidth;
                var navScrollWidth = navElement.scrollWidth;
                var buttonGap = rtl ? right : left;
                var scrollTo_1 = tabOffsetLeft - buttonGap;
                if (rtl) {
                    var rtlOffset = navOffsetWidth - tabOffsetWidth - 2 * buttonGap;
                    switch (_this._rtlScrollType) {
                        case 'default':
                            scrollTo_1 += navScrollWidth - navOffsetWidth - rtlOffset;
                            break;
                        case 'reverse':
                            scrollTo_1 = -scrollTo_1 + rtlOffset;
                            break;
                        default:
                            scrollTo_1 -= rtlOffset;
                    }
                }
                _this._animateScroll(scrollTo_1);
            }
        };
        _this._getDataAttributes = function () {
            var _a;
            return (_a = {},
                _a[dataHooks_1.TABS_DATA_KEYS.alignment] = _this.props.alignment,
                _a[dataHooks_1.TABS_DATA_KEYS.variant] = _this.props.variant,
                _a);
        };
        _this._handleKeyDown = function (e) {
            var lastTabIdx = Object.keys(_this._tabRefs).length - 1;
            var focusedTabIdx = _this.state.focusedTabIdx;
            switch (e.key) {
                case keyCodes_1.KEYS.ArrowLeft:
                case keyCodes_1.KEYS.ArrowRight: {
                    var tabIdx = void 0;
                    e.preventDefault();
                    if (e.key === keyCodes_1.KEYS.ArrowLeft) {
                        tabIdx = focusedTabIdx - 1 < 0 ? lastTabIdx : focusedTabIdx - 1;
                    }
                    else {
                        tabIdx = focusedTabIdx + 1 > lastTabIdx ? 0 : focusedTabIdx + 1;
                    }
                    return _this._setTabFocus(tabIdx);
                }
                default:
                    return;
            }
        };
        _this._setTabFocus = function (idx) {
            return _this.setState({ focusedTabIdx: idx }, function () { return _this._tabRefs[idx].focus(); });
        };
        _this._getSelectedTabRef = function (idx) { return _this._tabRefs[idx]; };
        _this._navRef = React.createRef();
        _this._listRef = React.createRef();
        return _this;
    }
    ScrollableTabs.prototype.componentDidMount = function () {
        var rtl = this.props.rtl;
        if (rtl) {
            this._setRtlScrollType();
        }
        this._updateComponent(true);
    };
    ScrollableTabs.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.rtl && !this._rtlScrollType) {
            this._setRtlScrollType();
        }
        if (prevProps.activeTabIndex !== this.props.activeTabIndex ||
            !isEqual(prevProps.items, this.props.items) ||
            prevProps.alignment !== this.props.alignment ||
            prevProps.variant !== this.props.variant ||
            prevProps.rtl !== this.props.rtl) {
            this._updateComponent(prevProps.activeTabIndex !== this.props.activeTabIndex ||
                prevProps.rtl !== this.props.rtl);
        }
    };
    ScrollableTabs.prototype.updateIndicatorPosition = function () {
        this._updateIndicatorPosition();
    };
    ScrollableTabs.prototype._setRtlScrollType = function () {
        this._rtlScrollType = normalize_scroll_left_1.detectScrollType();
    };
    ScrollableTabs.prototype._getNormalizedScrollLeft = function () {
        var rtl = this.props.rtl;
        var normalizedLeft = 0;
        if (this._navRef.current) {
            var _a = this._navRef.current, scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, offsetWidth = _a.offsetWidth;
            normalizedLeft = Math.abs(scrollLeft);
            if (rtl &&
                (this._rtlScrollType === 'negative' ||
                    this._rtlScrollType === 'reverse')) {
                normalizedLeft = scrollWidth - (normalizedLeft + offsetWidth);
            }
        }
        return normalizedLeft;
    };
    ScrollableTabs.prototype._getNormalizedScrollRight = function (scrollLeft) {
        var normalizedRight = 0;
        if (this._navRef.current) {
            var _a = this._navRef.current, scrollWidth = _a.scrollWidth, offsetWidth = _a.offsetWidth;
            normalizedRight = scrollWidth - (scrollLeft + offsetWidth);
        }
        return normalizedRight;
    };
    ScrollableTabs.prototype._updateComponent = function (shouldScroll) {
        if (shouldScroll === void 0) { shouldScroll = false; }
        this._updateIndicatorPosition();
        if (shouldScroll) {
            this._scrollToViewIfNeeded();
        }
    };
    ScrollableTabs.prototype._updateIndicatorPosition = function () {
        var selectedIndicatorRect = this.state.selectedIndicatorRect;
        var selectedTabRef = this._getSelectedTabRef(this.props.activeTabIndex);
        if (selectedTabRef) {
            var newWidth = selectedTabRef.offsetWidth, newLeft = selectedTabRef.offsetLeft;
            if (selectedIndicatorRect.left !== newLeft ||
                selectedIndicatorRect.width !== newWidth) {
                this.setState({
                    selectedIndicatorRect: { left: newLeft, width: newWidth },
                });
            }
        }
    };
    ScrollableTabs.prototype._getMaxMinScroll = function () {
        var rtl = this.props.rtl;
        var min = 0;
        var max = 0;
        if (this._navRef.current) {
            var _a = this._navRef.current, scrollWidth = _a.scrollWidth, offsetWidth = _a.offsetWidth;
            max = scrollWidth - offsetWidth;
            if (rtl) {
                // tslint:disable-next-line:switch-default
                switch (this._rtlScrollType) {
                    case 'negative':
                        min = -1 * max;
                        max = 0;
                }
            }
        }
        return {
            min: min,
            max: max,
        };
    };
    ScrollableTabs.prototype._animateScroll = function (scrollTo) {
        var _this = this;
        if (this._cancelAnimation) {
            this._cancelAnimation();
        }
        var _a = this._getMaxMinScroll(), min = _a.min, max = _a.max;
        var moveTo = Math.min(Math.max(scrollTo, min), max);
        var _b = animations_1.animateElementByProp({
            propToAnimate: 'scrollLeft',
            element: this._navRef.current,
            moveTo: moveTo,
            duration: 400,
        }), cancel = _b.cancel, done = _b.done;
        this._cancelAnimation = cancel;
        done
            .then(function () {
            _this._cancelAnimation = null;
        })
            .catch(function () { });
    };
    ScrollableTabs.prototype.scrollLeft = function () {
        this._scrollToSide(-1);
    };
    ScrollableTabs.prototype.scrollRight = function () {
        this._scrollToSide(1);
    };
    ScrollableTabs.prototype._scrollToSide = function (scrollDirection) {
        if (this._navRef.current) {
            var _a = this._navRef.current, scrollLeft = _a.scrollLeft, clientWidth = _a.clientWidth;
            var rtlDirectionFix = this._rtlScrollType === 'reverse' ? -1 : 1;
            var scrollDistance = rtlDirectionFix * scrollDirection * (clientWidth / 2);
            this._animateScroll(scrollLeft + scrollDistance);
        }
    };
    ScrollableTabs.prototype.getNavScrollPosition = function () {
        var scrollPosition = { scrollLeft: 0, scrollRight: 0 };
        if (this._navRef && this._navRef.current) {
            var scrollLeft = this._getNormalizedScrollLeft();
            scrollPosition.scrollLeft = scrollLeft;
            scrollPosition.scrollRight = this._getNormalizedScrollRight(scrollLeft);
        }
        return scrollPosition;
    };
    ScrollableTabs.prototype._addRef = function (ref, index) {
        if (ref) {
            this._tabRefs[index] = ref;
        }
    };
    ScrollableTabs.prototype.render = function () {
        var _this = this;
        var selectedIndicatorRect = this.state.selectedIndicatorRect;
        var _a = this.props, activeTabIndex = _a.activeTabIndex, onClickItem = _a.onClickItem, onScroll = _a.onScroll, items = _a.items, alignment = _a.alignment, variant = _a.variant, animateIndicator = _a.animateIndicator, className = _a.className, ariaLabel = _a["aria-label"], ariaLabeledBy = _a["aria-labelledby"], isTablist = _a.isTablist;
        return (React.createElement("div", __assign({ className: ScrollableTabs_st_css_1.st(ScrollableTabs_st_css_1.classes.root, { alignment: alignment, variant: variant, animateIndicator: animateIndicator }, className) }, this._getDataAttributes(), { "data-hook": dataHooks_1.TABS_DATA_HOOKS.scrollableTabs }),
            React.createElement(GenericComponent_1.Component, { className: ScrollableTabs_st_css_1.classes.nav, ref: this._navRef, onScroll: onScroll, "aria-labelledby": ariaLabeledBy, "aria-label": isTablist ? null : ariaLabel, renderAs: isTablist ? 'div' : 'nav' },
                React.createElement(GenericComponent_1.Component, __assign({ className: ScrollableTabs_st_css_1.classes.itemsList, ref: this._listRef, role: isTablist ? 'tablist' : undefined }, (isTablist
                    ? {
                        renderAs: 'div',
                        onKeyDown: this._handleKeyDown,
                        'aria-label': ariaLabel,
                    }
                    : { renderAs: 'ul' })), items.map(function (item, index) { return (React.createElement(Tab_1.Tab, { key: item.title + "-" + index, className: ScrollableTabs_st_css_1.classes.tab, item: item, index: index, "data-hook": dataHooks_1.TABS_DATA_HOOKS.tab + "-" + index, isActive: activeTabIndex === index, indicateActive: !animateIndicator, ref: function (ref) { return _this._addRef(ref, index); }, onClick: function (idx) {
                        if (isTablist) {
                            _this.setState({ focusedTabIdx: idx });
                        }
                        onClickItem(idx);
                    }, isTabButton: isTablist })); })),
                React.createElement("div", { className: ScrollableTabs_st_css_1.classes.selectedIndicator, style: selectedIndicatorRect })),
            React.createElement("div", { className: ScrollableTabs_st_css_1.classes.border })));
    };
    ScrollableTabs.defaultProps = {
        scrollButtons: {
            left: 0,
            right: 0,
        },
        isTablist: false,
    };
    return ScrollableTabs;
}(React.Component));
exports.ScrollableTabs = ScrollableTabs;
//# sourceMappingURL=ScrollableTabs.js.map